/* app/js/src/components/scheduler/libraryHeader/libraryHeader.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  position: relative;
  z-index: 2;
  -ms-transform: translateY(-5px);
  -webkit-transform: translateY(-5px);
  transform: translateY(-5px);
}
:host.active-list-mode header > button svg path {
  fill: #40c4ff;
}
header {
  display: flex;
  justify-content: flex-start;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
header > button {
  background-color: #ffffff;
  border: solid 1px #e1e6eb;
  box-shadow: none;
  border-radius: 4px;
  cursor: pointer;
  width: 30px;
  height: 26px;
  margin-right: 4px;
  display: inline-block;
  position: relative;
  padding: 0;
}
header > button svg path {
  fill: #abbed0;
}
header > button:focus {
  outline: none;
}
header .external-mam {
  cursor: pointer;
  display: flex;
  padding: 5px;
  align-items: center;
  border-radius: 5px;
  background: #ffffff;
  width: 30px;
  height: 30px;
}
search-input {
  flex-grow: 1;
}
.filter-icon {
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  flex-grow: 0;
  height: 25px;
  width: 25px;
}
.filter-icon ::ng-deep svg path {
  fill: #879baf !important;
}
.filter-icon-v {
  visibility: hidden;
  border-radius: 50%;
  background-color: #40c4ff;
  border-style: none;
  width: 18px;
  height: 18px;
  position: relative;
  top: -42px;
  right: -13px;
  display: block;
  margin: auto;
}
.filter-icons-container {
  -ms-transform: translateY(2px);
  -webkit-transform: translateY(2px);
  transform: translateY(2px);
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  height: 30px;
}
.filter-icons-container:active {
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
}
/*# sourceMappingURL=libraryHeader.component.css.map */
